/**
 * Documents du projet: sections libres (titre + fichiers).
 * GENERAL_DOSSIER_DOC_ID = id du document Firestore par propriété.
 */
export const GENERAL_DOSSIER_DOC_ID = 'default';
